import { render, staticRenderFns } from "./Typo5VConfig.vue?vue&type=template&id=2a39122e&scoped=true&"
import script from "./Typo5VConfig.vue?vue&type=script&lang=js&"
export * from "./Typo5VConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39122e",
  null
  
)

export default component.exports